import { arrayReduce } from 'fast-loops';
import cssifyKeyframeRule from './cssifyKeyframeRule';
export default function cssifyKeyframe(frames, animationName) {
  var prefixes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [''];
  var prerendered = arguments.length > 3 ? arguments[3] : undefined;
  var keyframe = prerendered || cssifyKeyframeRule(frames);
  return arrayReduce(prefixes, function (cssKeyframe, prefix) {
    return "".concat(cssKeyframe, "@").concat(prefix, "keyframes ").concat(animationName, "{").concat(keyframe, "}");
  }, '');
}